module.exports = __webpack_public_path__ + "img/companies.dc67fb49.jpg";